module.exports = __webpack_public_path__ + "img/img-event-tab01-m.b4afc381.png";